import React from 'react'
import './sticky-banner.css'

const StickyBanner = props => {

    const {stickyInfo, backgroundColor, showIcon} = props;

    const blueBackground = backgroundColor === 'blue';

    return (
        <div
            className={`mcb__stickyContainer ${blueBackground ? 'blueBackground' : ''}`}>
            {stickyInfo.map((info, index) => (
                <div className="propTile" key={index}>

                    <div className="propKey flex-center pb-4">
                        {showIcon && <i
                            className="fal fa-info-circle fs-base "
                            style={{color: blueBackground ? 'white' : 'black'}}
                        />} {info.name}
                    </div>
                    <div className="propVal"
                         style={{fontWeight: '500'}}
                    >
                        {info.value}
                    </div>
                </div>
            ))}
        </div>
    )
}
export default StickyBanner
